/**
 * @fileoverview Meta Ads Connect test ids — a dependency-free constants module
 * so e2e specs can import ids without pulling the component/service graph
 * (mirrors the funnel-insights testIds pattern).
 */

export const META_ADS_INLINE_CARD_TEST_IDS = {
  connectCard: 'meta-ads-inline-connect-card',
  connectButton: 'meta-ads-inline-connect-button',
  accountSelect: 'meta-ads-inline-account-select',
  periodSelect: 'meta-ads-inline-period-select',
  syncButton: 'meta-ads-inline-sync-button',
} as const;

/** G1 (AC-G1-1, SI-7) — explicit sync/report ad-account selection block. */
export const META_ADS_ACCOUNT_SELECTION_TEST_IDS = {
  section: 'meta-ads-account-selection-section',
  checkbox: (accountId: string) => `meta-ads-account-selection-checkbox-${accountId}`,
  selectedCount: 'meta-ads-account-selection-count',
  saveButton: 'meta-ads-account-selection-save',
  discardButton: 'meta-ads-account-selection-discard',
  notice: 'meta-ads-account-selection-notice',
  error: 'meta-ads-account-selection-error',
} as const;

/** Feature B (meta-utm-mapping-coverage) — «UTM mapping» block on the integration page. */
export const META_ADS_UTM_MAPPING_TEST_IDS = {
  section: 'meta-ads-utm-mapping-section',
  detectButton: 'meta-ads-utm-mapping-detect',
  suggestionCard: 'meta-ads-utm-mapping-suggestion',
  entityRow: (entity: string) => `meta-ads-utm-mapping-row-${entity}`,
  entitySelect: (entity: string) => `meta-ads-utm-mapping-select-${entity}`,
  applyButton: 'meta-ads-utm-mapping-apply',
  cancelButton: 'meta-ads-utm-mapping-cancel',
  savedCard: 'meta-ads-utm-mapping-saved',
  savedChip: (entity: string) => `meta-ads-utm-mapping-chip-${entity}`,
  redetectButton: 'meta-ads-utm-mapping-redetect',
  clearButton: 'meta-ads-utm-mapping-clear',
  degradedAlert: 'meta-ads-utm-mapping-degraded',
  snippet: 'meta-ads-utm-mapping-snippet',
  snippetCopy: 'meta-ads-utm-mapping-snippet-copy',
} as const;
